import React from 'react'
import isEmpty from 'lodash/isEmpty'
import DOMPurify from 'dompurify'
import { Container, Content } from './styles'

interface IProps {
  text: string
}

export const Complement = ({ text }: IProps): JSX.Element => {
  if (isEmpty(text)) return <></>

  return (
    <Container data-testid="property-complement">
      <Content dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }} />
    </Container>
  )
}
